import { useEffect, useRef, useState } from 'react';
import { ToasterService } from '../../../../services/ToasterService';
import { useNavigate, useParams } from 'react-router-dom';
import { OrdersService } from '../../../../services/OrdersService';
import { useLoader } from '../../../../context/LoaderContext';
import useDocumentTitle from '../../../../hooks/useDocumentTitle';
import { ORDER_STATUS_DELIVERED, STATUS_SUCCESS } from '../../../../utils/constants';
import { ProductsService } from '../../../../services/ProductsService';

export default function UseOrderDetailsPage() {
  useDocumentTitle('Namasteji Manikchand - Order-Details');
  let parsedUserData: any = {};
  const navigate = useNavigate();
  const { orderId }: any = useParams();
  const getUserLoginData = localStorage.getItem('userLoginData');
  const { loading, setLoading } = useLoader();
  const customerId = useRef('');
  const customerName = useRef('');
  const [productsList, setProductsList] = useState<any[]>([]);
  const [ordersDataArr, setOrdersDataArr] = useState<any>({});
  const orderStatusCode = useRef(0);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [reviews, setReviews] = useState<any[]>([]);

  useEffect(() => {
    if (getUserLoginData) {
      parsedUserData = JSON.parse(getUserLoginData);
      customerId.current = parsedUserData.customer_id;
      if (parsedUserData && parsedUserData.customer_id && orderId && orderId !== '') {
        customerName.current = parsedUserData.customer_name;
        getOrderDetails(orderId);
      } else {
        navigate('/login');
      }
    }
  }, []);

  async function getOrderDetails(orderId: string) {
    try {
      setLoading(true);
      const resp = await OrdersService.Details(orderId);
      setLoading(false);
      if (resp && resp.message && resp.message.items && resp.message.items.length > 0) {
        const statusTimeline = resp.message.status_timeline;
        const lastIndex = statusTimeline.length - 1;
        orderStatusCode.current = statusTimeline[lastIndex]?.code;
        if (orderStatusCode.current == 4) {
          orderStatusCode.current = ORDER_STATUS_DELIVERED;
        }
        console.log('Resp Order Details:-', resp);
        setOrdersDataArr(resp.message);
        setProductsList(resp.message.items);
      } else {
        ToasterService.Error('Order not found!..');
        navigate('/products');
      }
    } catch (err) {
      setLoading(false);
      ToasterService.Error('Server Error!..');
    }
  }

  function gotoProductDetails(productSlug: string) {
    navigate(`/product/details/${productSlug}`);
  }

  const handleOpenSlider = () => {
    setIsSliderOpen(true);
  };

  async function handleSubmitRatingReview(reviewsData: any[]) {
    try {
      if (reviewsData && reviewsData.length > 0 && customerId.current) {
        setLoading(true);
        const payload = {
          data: {
            title: customerName.current,
            customer_id: customerId.current,
            product_rating: reviewsData,
          },
        };
        console.log('Submitted reviews payload:', payload);
        const resp = await ProductsService.RatingReview(payload);
        console.log('Submitted reviews:', resp);
        setLoading(false);
        if (resp && resp.message && resp.message.status === STATUS_SUCCESS) {
          getOrderDetails(orderId);
          ToasterService.Success('Reviews submitted successfully.');
        } else {
          ToasterService.Error('Somthing else please try again');
        }
      }
    } catch (err: any) {
      ToasterService.Error('Server Error..');
    }
  }

  const ratingReviewObj = {
    isSliderOpen,
    setIsSliderOpen,
    reviews,
    setReviews,
    handleOpenSlider,
    handleSubmitRatingReview,
  };

  const states = {
    ordersDataArr,
    productsList,
    navigate,
    gotoProductDetails,
  };

  return {
    states,
    orderStatusCode,
    ratingReviewObj,
  };
}
